import React, { useState, useCallback } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "components/Card/CardHeader";
import CardText from "components/Card/CardText";

import ChapterRangeDialog from "./ChapterRange/ChapterRanageDialog";
import FiscalYearDialog from "./FiscalYear";
import ManageMailingAddressDialog from "./ManageMailingAddress";

const useStyles = makeStyles(theme => ({
  marginBottom: {
    marginBottom: theme.spacing(3)
  },
  cursorPointer: {
    cursor: "pointer"
  }
}));

const AdminArea = props => {
  const classes = useStyles();
  const [chapterRangeDialogOpen, setChapterRangeDialogOpen] = useState(false);
  const [fiscalYearDialogOpen, setFiscalYearDialogOpen] = useState(false);
  const [mailingAddressDialogOpen, setMailingAddressDialogOpen] =
    useState(false);
  const history = useHistory();

  const handleChapterRangeDialog = useCallback(
    open => () => {
      setChapterRangeDialogOpen(open);
    },
    []
  );

  const handleFiscalYearDialog = useCallback(
    open => () => {
      setFiscalYearDialogOpen(open);
    },
    []
  );

  const handleManageMailingAddressDialog = useCallback(
    open => () => {
      setMailingAddressDialogOpen(open);
    },
    []
  );

  const handleHelpText = useCallback(() => {
    history.push("/admin/settings/help-text");
  }, [history]);

  const handleMemberCounts = useCallback(() => {
    history.push("/admin/settings/member-counts");
  }, [history]);

  const handleChapterBudgets = useCallback(() => {
    history.push("/admin/settings/chapter-budgets");
  }, [history]);

  return (
    <Container>
      <div style={{ height: "30px" }}></div>
      <CardHeader color="primary" text>
        <CardText color="primary">
          <Typography variant="h4">ACC Admin Area</Typography>
        </CardText>
      </CardHeader>
      <div style={{ height: "20px" }}></div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Card
            className={classes.cursorPointer}
            onClick={handleChapterRangeDialog(true)}
          >
            <CardContent>
              <Typography variant="h5">
                Manage Chapter Range Definitions
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card className={classes.cursorPointer} onClick={handleMemberCounts}>
            <CardContent>
              <Typography variant="h5">Chapter Member Counts</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card className={classes.cursorPointer} onClick={handleHelpText}>
            <CardContent>
              <Typography variant="h5">Manage Help Text</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card
            className={classes.cursorPointer}
            onClick={handleFiscalYearDialog(true)}
          >
            <CardContent>
              <Typography variant="h5">Open Fiscal Year</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card
            className={classes.cursorPointer}
            onClick={handleChapterBudgets}
          >
            <CardContent>
              <Typography variant="h5">Manage Chapter Budgets</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card
            className={classes.cursorPointer}
            onClick={handleManageMailingAddressDialog(true)}
          >
            <CardContent>
              <Typography variant="h5">Mailing Address</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <ChapterRangeDialog
        open={chapterRangeDialogOpen}
        onClose={handleChapterRangeDialog(false)}
      />
      <FiscalYearDialog
        open={fiscalYearDialogOpen}
        onClose={handleFiscalYearDialog(false)}
      />
      <ManageMailingAddressDialog
        open={mailingAddressDialogOpen}
        onClose={handleManageMailingAddressDialog(false)}
      />
    </Container>
  );
};

export default AdminArea;
